import React from 'react';
import { Button } from './ui/button';

const CTA = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-r from-[#1976D2] via-[#1E88E5] to-[#42A5F5]">
      <div className="max-w-5xl mx-auto px-4 text-center">
        <h2 className="text-4xl md:text-5xl font-serif text-white mb-4 drop-shadow-lg">
          Step inside, or <span className="italic text-[#FF9800]">step online.</span>
        </h2>
        <p className="text-lg text-white/95 mb-8 drop-shadow-md">
          Whether you need support, want to volunteer, or wish to contribute – EWRF is here for you. Take the first step today.
        </p>
        <div className="flex flex-wrap items-center justify-center gap-4">
          <Button
            onClick={() => scrollToSection('contact')}
            className="bg-[#FF9800] hover:bg-[#F57C00] text-white px-8 py-6 text-base font-semibold transition-all shadow-xl"
          >
            Book Counselling
          </Button>
          <Button
            onClick={() => scrollToSection('contact')}
            variant="outline"
            className="border-2 border-white text-white hover:bg-white/20 backdrop-blur-sm px-8 py-6 text-base font-semibold transition-all"
          >
            Volunteer
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTA;
